import { Link } from 'react-router-dom';
import { ReactComponent as Arrow } from 'assets/icons/button/arrow.svg';
import ROUTES from 'constants/routes';
import { getImageUrl } from 'helpers';
import useMediaQuery from 'hooks/useMediaQuery';

const LoactionCountry = ({ data }) => {
    const isMobile = useMediaQuery('max-width: 640px')
    const { flag, name, hero, slug } = data.attributes;

    const imageUrl = getImageUrl(flag);

    return (
        <Link to={`${ROUTES.location}/${slug}`} className="home-locations-item">
            <img src={imageUrl} alt="" className="home-locations-item__flag" />
            <div className="home-locations-item__body">
                <div className="button-text">
                    {name}
                    {
                        !isMobile && <Arrow className="arrow" />
                    }
                </div>
                <div className="body2">{hero.title}</div>
            </div>
        </Link>
    );
};

export default LoactionCountry;
